import Http from '@/support/http';
import S from '@/support/string';

export default {
	getSomethings(context, payload) {

		if (payload) {

			const queryString = S.makeQueryString(payload);

			return Http.get(`somethings/${ payload.something }${ queryString }`).then((response) => {

				context.commit('SET_SOMETHINGS', response.data);

				return response;

			});

		}
	}
};



// WEBPACK FOOTER //
// ./sources/app/sample/store/actions.js